import { createFrontendLogger } from '@template-project/storefront-shared';

export const campaignLogger = createFrontendLogger('storefront-campaign');
